import { useEffect, useRef } from 'react';

export const useTitle = (title: string) => {
  const prevTitle = useRef<string>(document.title);

  useEffect(() => {
    const previousTitle = prevTitle.current;

    if (previousTitle === title) {
      return;
    }
    document.title = title;

    return () => {
      document.title = previousTitle;
    }
  }, [ title ]);
};
